import React from 'react';
import { Card } from 'react-bootstrap';
import AlternativeItem from './AlternativeItem';

const AlternativesSection = ({ alternatives }) => {
    const hasAlternatives = alternatives?.length > 0;

    return (
        <Card className="clean-card shadow mb-4">
            <div className="card-header">
                <h3 className="mb-0">
                    <span className="alternatives-icon">🌿</span> Healthy Alternatives
                </h3>
            </div>

            <Card.Body>
                {hasAlternatives ? (
                    <div className="alternatives-list">
                        {alternatives.map((alt, idx) => (
                            <AlternativeItem key={idx} alternative={alt} index={idx} />
                        ))}
                    </div>
                ) : (
                    <div className="no-alternatives text-center p-4">
                        <div className="empty-icon">🚫</div>
                        <p className="text-muted">No alternatives suggested</p>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default AlternativesSection;
